const STORAGE_KEY = 'boujie_lgpd_consent';
const STORAGE_PERIOD_KEY = 'boujie_lgpd_consent_period';

function getCurrentMonthKey() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

function setTrackingConsent(accepted) {
  const applyConsent = () => {
    const privacyApi = window.Shopify?.customerPrivacy;

    if (privacyApi?.setTrackingConsent) {
      try {
        privacyApi.setTrackingConsent(accepted, () => {});
      } catch (error) {
        console.warn('Unable to update Shopify customer privacy consent.', error);
      }
    }
  };

  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], applyConsent);
    return;
  }

  applyConsent();
}

function initBanner(banner) {
  const currentMonth = getCurrentMonthKey();
  const accepted = localStorage.getItem(STORAGE_KEY);
  const consentPeriod = localStorage.getItem(STORAGE_PERIOD_KEY);
  const root = document.documentElement;

  const updateOffset = () => {
    if (banner.hidden) {
      root.style.removeProperty('--lgpd-banner-offset');
      return;
    }

    const height = banner.getBoundingClientRect().height;
    root.style.setProperty('--lgpd-banner-offset', `${Math.ceil(height + 16)}px`);
  };

  if ((accepted === 'accepted' || accepted === 'rejected') && consentPeriod === currentMonth) {
    banner.hidden = true;
    updateOffset();
    return;
  }

  if ((accepted === 'accepted' || accepted === 'rejected') && !consentPeriod) {
    localStorage.setItem(STORAGE_PERIOD_KEY, currentMonth);
    banner.hidden = true;
    updateOffset();
    return;
  }

  banner.hidden = false;
  updateOffset();

  const acceptButton = banner.querySelector('[data-lgpd-accept]');
  const rejectButton = banner.querySelector('[data-lgpd-reject]');

  const closeBanner = (status) => {
    localStorage.setItem(STORAGE_KEY, status);
    localStorage.setItem(STORAGE_PERIOD_KEY, currentMonth);
    banner.hidden = true;
    updateOffset();
  };

  acceptButton?.addEventListener('click', () => {
    setTrackingConsent(true);
    closeBanner('accepted');
  });

  rejectButton?.addEventListener('click', () => {
    setTrackingConsent(false);
    closeBanner('rejected');
  });

  window.addEventListener('resize', updateOffset, { passive: true });
}

document.querySelectorAll('[data-lgpd-banner]').forEach(initBanner);
